/* eslint-disable id-length */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import {
  number, object, oneOfType, string, bool, array
} from 'prop-types';
import { useDesignStore } from '../store/design/context';

const SCALE = 0.5;

function transformWithZoom(cssTransform) {
  if (cssTransform) {
    return {
      ...cssTransform,
      x: cssTransform.x / SCALE,
      y: cssTransform.y / SCALE,
    };
  }
  return cssTransform;
}

export const Draggable = (props) => {
  const {
    id,
    children,
    isDraggable,
    isVisualizerDrag,
    choiceId,
    imagePosition,
    bundleId,
  } = props;

  const design = useDesignStore((state) => state.design);
  const {
    attributes, listeners, setNodeRef, transform,
  } = useDraggable({
    id: design.isZoomModalOpen ? 'no-id' : id,
    disabled: !isDraggable || design.isZoomModalOpn,
    data: {
      bundleId,
      choiceId: id,
      configuratorChoiceId: choiceId,
      ...props,
    },
  });

  const trans = transformWithZoom(transform);
  const isBase = props?.children?.props?.type === 'Base';

  const style = transform && {
    zIndex: 99,
    touchAction: 'manipulation',
    ...((isVisualizerDrag) && {
      transform: isBase
        ? `scale(${SCALE}) translate3d(${trans.x}px, ${trans.y}px, 0)`
        : `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      ...(props?.children?.props?.type === 'Base' && {
        paddingTop: 50,
      }),
    })
  };

  const baseStyles = {
    ...imagePosition,
    transformOrigin: '50% 50%',
    position: 'relative',
    width: imagePosition.width || 'inherit',
    height: 'inherit',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none'
  };

  return (
    <>
      {design.isZoomModalOpen ? (
        <button
          type="button"
          style={{ ...baseStyles, ...style }}
        >
          {children}
        </button>
      ) : (
        <button
          type="button"
          ref={setNodeRef}
          style={{ ...baseStyles, ...style }}
          {...listeners}
          {...attributes}
        >
          {children}
        </button>
      )}
    </>
  );
};

Draggable.propTypes = {
  id: oneOfType([number, string]),
  // eslint-disable-next-line react/forbid-prop-types
  children: oneOfType([object, array]),
  isDraggable: bool,
  isVisualizerDrag: bool,
  choiceId: oneOfType([number, string]),
  bundleId: oneOfType([number, string, bool]),
  isDragging: bool,
  // eslint-disable-next-line react/forbid-prop-types
  imagePosition: object,
};

Draggable.defaultProps = {
  id: null,
  children: {},
  isDraggable: true,
  isVisualizerDrag: false,
  choiceId: 0,
  bundleId: null,
  isDragging: false,
  imagePosition: {
    right: {
      right: 28,
      top: -5,
    },
    left: {
      left: 32,
      top: -18,
    },
  }
};
